import { useState, useEffect } from "react";
import { Link, useLocation } from "wouter";
import { Menu, X } from "lucide-react";

const navLinks = [
  { href: "/", label: "الرئيسية" },
  { href: "/features", label: "المميزات" },
  { href: "/pricing", label: "الأسعار" },
  { href: "/about", label: "من نحن" },
  { href: "/contact", label: "تواصل معنا" },
];

export default function MarketingNavbar() {
  const [location] = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => { setMobileOpen(false); }, [location]);

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 transition-all duration-300"
      style={{
        background: scrolled ? "rgba(253,250,247,0.97)" : "#FDFAF7",
        borderBottom: `1px solid ${scrolled ? "#e8ddd4" : "#f0e8e0"}`,
        boxShadow: scrolled ? "0 2px 16px rgba(26,15,8,0.07)" : "none",
        backdropFilter: scrolled ? "blur(12px)" : "none",
      }}
    >
      <div className="container">
        <div className="flex items-center justify-between h-16" dir="rtl">
          <Link href="/" className="flex items-center gap-2 cursor-pointer">
              <img src="/nexus-cart-icon.png" alt="نكسس كارت" className="h-8 w-8 object-contain" onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = "none"; }} />
              <span className="font-black text-lg" style={{ fontFamily: "'Cairo', sans-serif", color: "#1a0f08" }}>نكسس كارت</span>
            </Link>

          <nav className="hidden md:flex items-center gap-0.5">
            {navLinks.map((link) => (
              <Link key={link.href} href={link.href}
                  className="px-4 py-2 rounded-lg text-[0.9375rem] transition-all cursor-pointer"
                  style={{
                    fontFamily: "'Tajawal', sans-serif",
                    color: location === link.href ? "#A47764" : "#4a3728",
                    background: location === link.href ? "rgba(164,119,100,0.08)" : "transparent",
                    fontWeight: location === link.href ? 700 : 500,
                  }}
                >
                  {link.label}
                </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link href="/login" className="font-medium text-sm px-3 py-2 rounded-lg" style={{ fontFamily: "'Tajawal', sans-serif", color: "#5a4035" }}>دخول</Link>
            <Link href="/register">
              <button
                className="h-9 px-5 text-sm font-bold rounded-xl transition-all"
                style={{ background: "#A47764", color: "#fff", border: "none", fontFamily: "'Cairo', sans-serif" }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#8a5f4a")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "#A47764")}
              >
                ابدأ الآن
              </button>
            </Link>
          </div>

          <button
            className="md:hidden p-2 rounded-lg transition-colors"
            style={{ color: "#4a3728" }}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="القائمة"
          >
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden" style={{ background: "#FDFAF7", borderTop: "1px solid #e8ddd4" }}>
          <div className="container py-3 space-y-0.5" dir="rtl">
            {navLinks.map((link) => (
              <Link key={link.href} href={link.href}
                  className="block px-4 py-3 rounded-lg text-sm font-medium cursor-pointer"
                  style={{
                    fontFamily: "'Tajawal', sans-serif",
                    color: location === link.href ? "#A47764" : "#4a3728",
                    background: location === link.href ? "rgba(164,119,100,0.08)" : "transparent",
                  }}
                >
                  {link.label}
                </Link>
            ))}
            <div className="pt-3 border-t flex flex-col gap-2 mt-2" style={{ borderColor: "#e8ddd4" }}>
              <Link href="/login" className="block text-center px-4 py-2.5 rounded-lg text-sm font-medium" style={{ border: "1px solid #e8ddd4", color: "#4a3728", fontFamily: "'Tajawal', sans-serif" }}>
                  دخول
                </Link>
              <Link href="/register">
                <button className="w-full h-10 text-sm font-bold rounded-xl" style={{ background: "#A47764", color: "#fff", border: "none", fontFamily: "'Cairo', sans-serif" }}>
                  ابدأ الآن
                </button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
